<template>
  <v-dialog persistent :width="dialog.width" v-model="isActive">
    <v-card class="ui-module-card" color="primary">
      <v-card-title class="d-flex font-weight-bold justify-space-between">
        <div>{{ dialog.title }}</div>
        <v-btn icon @click="closeDialog()"> <v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <component :is="dialog.component" v-bind="dialog.props" v-on="dialog.listeners || {}" @close="closeDialog" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'BaseDialogComponent',
  computed: {
    ...mapGetters('dialog', {
      dialog: 'getDialog',
    }),
    isActive() {
      return this.dialog.type !== 'DEFAULT'
    },
  },

  methods: {
    ...mapActions('dialog', ['closeDialog']),
  },
}
</script>
